import { Button, Divider } from 'antd'
import { faLink, faHourglassHalf } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { IWebinar } from 'interfaces/webinars'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { disablePanelistAccess, formatWebinarTimeRange } from '../helpers'
import { ModalPanelist } from '../modal'
import {
  Title,
  Course,
  DateTimeContainer,
  DateTimeText,
  Separator,
  StartWebinarButton,
  LinksButton,
  ButtonsContainer,
  SoonButton,
} from './styled'

interface IWebinarMobileCardProps {
  webinar: IWebinar
}

export const WebinarMobileCard = ({ webinar }: IWebinarMobileCardProps) => {
  const prefix = 'webinars'
  const { t } = useTranslation()
  const [panelistModal, setPanelistModal] = useState(false)
  const [soonModal, setSoonModal] = useState(false)

  return (
    <>
      <Title>{webinar.title}</Title>
      <Course>{webinar.course}</Course>
      <DateTimeContainer>
        <DateTimeText>
          {format(new Date(webinar.startTime), 'dd/MMM/yyyy', { locale: es })}
        </DateTimeText>
        <Separator>-</Separator>
        <DateTimeText>
          {formatWebinarTimeRange(webinar.startTime, webinar.duration)}
        </DateTimeText>
      </DateTimeContainer>
      <ButtonsContainer>
        {!disablePanelistAccess(webinar.startTime) ? (
          <>
            <a target="_blank" href={webinar.hostUrl}>
              <StartWebinarButton>
                <Button type="primary">
                  {t(`${prefix}.table.btnStartWebinar`)}
                </Button>
              </StartWebinarButton>
            </a>
            <LinksButton>
              <Button type="default" onClick={() => setPanelistModal(true)}>
                <FontAwesomeIcon
                  icon={faLink}
                  style={{ paddingRight: '4px' }}
                />
                {t(`${prefix}.table.btnLinks`)}
              </Button>
            </LinksButton>
          </>
        ) : (
          <SoonButton>
            <Button onClick={() => setSoonModal(true)}>
              <FontAwesomeIcon
                icon={faHourglassHalf}
                size="xs"
                style={{ paddingRight: '8px' }}
              />
              {t(`${prefix}.table.btnSoonWebinar`)}
            </Button>
          </SoonButton>
        )}
      </ButtonsContainer>
      <Divider />
      <ModalPanelist
        show={panelistModal}
        close={() => setPanelistModal(false)}
        panelList={webinar.panelists || []}
      />
      <Modal
        isOpen={soonModal}
        title={t(`${prefix}.table.btnSoonWebinar`)}
        maxwidth={800}
        maxheight={400}
        isInfo
        actions={
          <ModalButtons
            secondaryText={t(`${prefix}.modal.btnClose`)}
            secondaryAction={() => setSoonModal(false)}
          />
        }
        close={() => setSoonModal(false)}
      >
        <div style={{ paddingTop: '16px' }}>
          {t(`${prefix}.modal.modalPanelistResponsiveDescription`)}
        </div>
      </Modal>
    </>
  )
}
